module.exports = __webpack_public_path__ + "static/media/confirmacion__admiracion.aacf090e.svg";